export default __webpack_public_path__ + "static/media/topping_yellowalpaca.01ff5634.jpg";